import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from "@/api/PMS/communityPartyBuilding/activityType"; // import { fetchList as fetchAreaList } from "@/api/PMS/baseInformation/manageArea";

import { fetchCreate, fetchUpdate, fetchDetail, fetchAudit } from "@/api/PMS/communityPartyBuilding/activityManage";
import Tinymce from "@/components/Tinymce"; // import { fetchDict } from "@/api/MLXC/countryServe/partyManage";

import addChargeItem from "./addChargeItem";
import configList from '@/views/PMS/performancecenter/theaterManage/configList.vue';
export default {
  components: {
    Tinymce: Tinymce,
    addChargeItem: addChargeItem,
    configList: configList
  },
  props: {
    showDialog: Boolean,
    isDetail: Boolean,
    isAudit: Boolean,
    isDashboard: Boolean,
    keyValue: {
      type: Number,
      default: -1
    },
    viewType: String
  },
  data: function data() {
    var _this = this;

    var fileMustUpload = function fileMustUpload(rule, value, callback) {
      console.log(_this.fileList, "sssss");

      if (_this.fileList.length === 0) {
        // 未上传文件
        callback("请上传活动封面");
      }

      callback();
    };

    return {
      rules: {
        activityTitle: [{
          required: true,
          message: "请输入项目名称",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "change"
        }],
        activityLocation: [{
          required: true,
          message: "请输入活动地点",
          trigger: "blur"
        }, {
          min: 1,
          max: 50,
          message: "长度在 1 到 50 个字符",
          trigger: "change"
        }],
        files: [{
          required: true,
          validator: fileMustUpload,
          trigger: "blur"
        }],
        activityOption: [{
          required: true,
          message: "请输入活动内容",
          trigger: "change"
        }, {
          min: 1,
          max: 30000,
          message: "长度在 1 到 30000 个字符",
          trigger: "change"
        }],
        activityId: [{
          required: true,
          message: "请选择项目类型",
          trigger: "change"
        }],
        activeDates: [{
          required: true,
          message: "请选择活动时间",
          trigger: "change"
        }],
        isCharge: [{
          required: true,
          message: "请选择是否计费",
          trigger: "change"
        }],
        actiOrder: [{
          required: true,
          message: '请输入排序',
          trigger: 'change'
        }],
        activityPlannedEnrollment: [{
          required: true,
          message: "请输入报名人数",
          trigger: "blur"
        }, {
          required: true,
          message: "请输入报名人数",
          trigger: "change"
        }],
        registrationDates: [{
          required: true,
          message: "请选择报名时间",
          trigger: "change"
        }]
      },
      propstree: {
        label: "deptName",
        value: "deptId",
        children: "childDept"
      },
      readonly: 1,
      activeDates: "",
      registrationDates: [],
      files: [],
      listObj: [],
      toolbar: [""],
      typeOption: [],
      oldImgList: [],
      removeList: [],
      activeTypeOption: [],
      uploadUrl: "",
      downloadUrl: "",
      addList: [],
      uploadList: [],
      dialogImageUrl: "",
      picUrl: "",
      imageUrl: "",
      dialogVisible: false,
      fileList: [],
      childData: {
        activityId: 5
      },
      appType: "",
      isChargeOption: [{
        id: 0,
        value: "不计费"
      }, {
        id: 1,
        value: "计费"
      }],
      id: -1,
      titleConfig: '',
      activityAuditStatus: null,
      activityItem: null,
      activityIndex: -1,
      title: "",
      dialogFormVisible: false,
      dialogPlacePriceFormVisible: false
    };
  },
  computed: {
    isBuildParty: function isBuildParty() {
      return this.$route.path.indexOf("partyactivityManage") > -1;
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD; // 获取路由的配置

    var appType = this.$route.query.appType;

    if (appType !== undefined) {
      this.appType = parseInt(appType);
    }

    this.init();
    this.getTypeOption();
  },
  methods: {
    changeCharge: function changeCharge() {
      this.childData.changeActivityItemVos = [];

      if (this.childData.activityId == 1) {
        this.childData.isCharge = 0;
      } else if (this.childData.activityId == 2) {
        this.childData.isCharge = 1;
      } else if (this.childData.activityId == 3) {
        this.childData.isCharge = 0;
      }
    },
    handPass: function handPass() {
      var _this2 = this;

      fetchAudit({
        id: this.keyValue,
        state: 2
      }).then(function (res) {
        if (res.data.code === 200) {
          _this2.$emit("handCancle", true);

          _this2.Alert({
            alertType: "update",
            message: "审核通过"
          });
        }
      });
    },
    handUnPass: function handUnPass() {
      var _this3 = this;

      fetchAudit({
        id: this.keyValue,
        state: 3
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.$emit("handCancle", true);

          _this3.Alert({
            alertType: "update",
            message: "审核未通过"
          });
        }
      });
    },
    handCancleConfig: function handCancleConfig() {
      this.dialogPlacePriceFormVisible = false;
    },
    handleConfig: function handleConfig(id, activityAuditStatus) {
      this.id = id;
      this.activityAuditStatus = activityAuditStatus;
      this.titleConfig = "场次配置";
      this.dialogPlacePriceFormVisible = true;
    },
    getTypeOption: function getTypeOption() {
      var _this4 = this;

      fetchList({
        appType: this.appType,
        page: 1,
        limit: 9999
      }).then(function (res) {
        if (res.data.code === 200) {
          _this4.activeTypeOption = res.data.data;
        }
      });
    },
    init: function init() {
      var _this5 = this;

      this.delFileList = [];
      this.fileList = [];
      this.files = [];
      this.addList = [];
      this.removeList = [];
      this.$nextTick(function () {
        _this5.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this5.childData = response.data.data;
          _this5.files = _this5.childData.activeFileListVoList.map(function (item) {
            return {
              fileId: item.fileId,
              name: item.fileName,
              url: item.fileId
            };
          });
          _this5.fileList = _this5.files;

          _this5.$set(_this5.childData, "activeDates", [_this5.childData.activityBeginDate, _this5.childData.activityEndDate]);

          _this5.$set(_this5.childData, "registrationDates", [_this5.childData.enrollmentBeginDate, _this5.childData.enrollmentEndDate]);

          var that = _this5;
          setTimeout(function () {
            that.$refs["editor"].setContent(that.childData.activityOption);
            that.$refs["viewer"].setContent(that.childData.activityOption);
          }, 100);
        });
      } else {
        this.childData = {
          activityId: 5,
          changeActivityItemVos: []
        };
        var that = this;
        setTimeout(function () {
          that.$refs["editor"].setContent("");
          if (this.isDetail) that.$refs["viewer"].setContent("");
        }, 100);
      }
    },
    changeLocationValue: function changeLocationValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.id === val;
      });
      var getName = "";
      getName = obj.locationName;
      console.log(getName);
    },
    handleActiveDates: function handleActiveDates(val) {
      if (this.childData.activityId == 1 && val && this.childData.registrationDates && this.childData.registrationDates.length > 0) {
        var registrationEndTime = new Date(this.childData.registrationDates[1]).getTime(); //  报名结束时间

        var activeBeginTime = new Date(val[0]).getTime() - 3600 * 8 * 1000; // 活动开始时间

        if (activeBeginTime < registrationEndTime) {
          this.$message.error("活动开始时间必须在报名结束时间之后");
          this.$set(this.childData, "activeDates", []);
        }
      }
    },
    handleRegistrationDate: function handleRegistrationDate(val) {
      if (val && this.childData.activeDates && this.childData.activeDates.length > 0) {
        var activeBeginTime = new Date(this.childData.activeDates[0]).getTime() - 3600 * 8 * 1000; // 活动开始时间

        var registrationEndTime = new Date(val[1]).getTime(); // 报名结束时间

        if (registrationEndTime > activeBeginTime) {
          this.$message.error("报名结束时间必须在活动开始时间之前");
          this.$set(this.childData, "registrationDates", []);
        }
      }
    },
    handCreate: function handCreate() {
      var _this6 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this6.childData.activityBeginDate = _this6.childData.activeDates[0];
          _this6.childData.activityEndDate = _this6.childData.activeDates[1];

          if (!_this6.isBuildParty) {
            _this6.childData.enrollmentBeginDate = _this6.childData.registrationDates[0];
            _this6.childData.enrollmentEndDate = _this6.childData.registrationDates[1];
          }

          if (!_this6.childData.activityOption) {
            _this6.Alert({
              alertType: "valid",
              message: "活动内容不能为空"
            });

            return;
          } // if (this.childData.isCharge == 1) {


          if (_this6.childData.changeActivityItemVos == null || _this6.childData.changeActivityItemVos.length == 0) {
            _this6.Alert({
              alertType: "valid",
              message: "收费明细不能为空"
            });

            return;
          } // } else {
          //   this.childData.changeActivityItemVos = [
          //     {
          //       itemName: this.childData.activityTitle,
          //       totalNumber: this.childData.activityPlannedEnrollment,
          //       itemOrder: 1,
          //       checkNum: 1
          //     }
          //   ];
          // }


          _this6.childData.changeActiveFileVos = _this6.fileList;

          if (_this6.isBuildParty) {//this.childData.appType = 0
          } else {//this.childData.appType = 1
            }

          if (_this6.keyValue > 0) {
            _this6.childData.changeNoticeFileVos = _this6.addList; //this.childData.deleteNoticeFileVo = { ids: this.removeList }

            fetchUpdate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "update"
                });
              }
            });
          } else {
            _this6.childData.appType = _this6.appType;
            _this6.childData.activeFileListVoList = _this6.fileList;
            fetchCreate(_this6.childData).then(function (res) {
              if (res.data.code == 200) {
                _this6.$emit("handCancle", true);

                _this6.Alert({
                  alertType: "add"
                });
              }
            });
          }
        } else {
          _this6.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", "repairAdd");
    },
    // 上传图片成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        fileId: file.response.data[0].fileId,
        name: file.response.data[0].fileName
      });
    },
    handleError: function handleError(err, file) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: "error"
      });
    },
    handlePreview: function handlePreview(file) {
      if (file.response) {
        // 当还未保存到业务逻辑中时的预览图片
        if (file.name.includes("png") || file.name.includes("jpg") || file.name.includes("jpeg")) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.response.data[0].fileId;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      } else {
        // 当已保存到业务逻辑中时的预览图片
        if (file.name.includes("png") || file.name.includes("jpg") || file.name.includes("jpeg")) {
          // 当附件是图片的时候在线打开
          this.dialogVisible = true;
          this.dialogImageUrl = this.downloadUrl + file.url;
        } else {
          // 当附件是文件的时候在线下载
          this.dialogImageUrl = this.downloadUrl + file.url;
          this.handleDownload(this.dialogImageUrl, file.name);
        }
      }
    },
    // 移除图片之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    handleExceed: function handleExceed() {
      this.$message({
        message: "最多只能上传1个文件!",
        type: "danger"
      });
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      extension = extension.toLowerCase();
      var isLt2M = file.size / 1024 / 1024 < 10;
      var fileFormatOK = extension === "jpg" || extension === "jpeg" || extension === "png" || extension === "gif";

      if (!fileFormatOK) {
        this.$message({
          message: "只支持上传 jpg/png/gif 格式文件!",
          type: "error"
        });
        return false;
      }

      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "error"
        });
        return false;
      }
    },
    // 移除图片
    handleRemove: function handleRemove(file, fileList) {
      var _this7 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      console.log("移除前", this.fileList);
      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.fileId) {
          _this7.fileList.splice(index, 1);

          return;
        }
      });
      console.log("移除后", this.fileList);
      this.oldImgList.forEach(function (col, n) {
        if (currentUrl === col.filePath) {
          _this7.removeList.push(col.fileId);

          return;
        }
      });
      this.addList.forEach(function (item, index) {
        if (item.filePath === currentUrl) {
          _this7.addList.splice(index, 1);
        }
      });
    },
    // 下载文件
    handleDownload: function handleDownload(url, name) {
      var link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
    },
    // 判断上传的文件类型，方便数据库保存
    judgeFileType: function judgeFileType(str) {
      if (str === "image/png" || str === "image/jpeg" || str === "image/jpg") {
        return 2;
      } else {
        return 1;
      }
    },
    // 创建
    handleCreate: function handleCreate() {
      this.activityItem = null;
      this.activityIndex = -1;
      this.title = "添加收费明细";
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(activityItem, index) {
      this.activityIndex = index;
      this.activityItem = activityItem;
      this.title = "编辑收费明细";
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete(activityItem, index) {
      var _this8 = this;

      this.$confirm("你确定是要删除这条收费明细, 是否继续?", "提示").then(function () {
        _this8.childData.changeActivityItemVos.splice(index, 1);
      });
    },
    handItemCancle: function handItemCancle(reload, data) {
      var _this9 = this;

      if (reload) {
        if (data != null) {
          if (this.activityItem == null) {
            //新增
            this.childData.changeActivityItemVos.push(data);
          } else {
            //编辑
            this.childData.changeActivityItemVos.forEach(function (element, index) {
              if (index == _this9.activityIndex) {
                // this.childData.changeActivityItemVos[index] = data
                _this9.$set(_this9.childData.changeActivityItemVos, index, data);
              }
            });
          }
        }
      }

      console.log(this.childData.changeActivityItemVos);
      this.dialogFormVisible = false;
    }
  }
};